import { render } from "./CustomSelect2.vue?vue&type=template&id=883dd900"
import script from "./CustomSelect2.vue?vue&type=script&lang=js"
export * from "./CustomSelect2.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__